/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TotalAffected/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function TotalAffected({
  children,
  viewPath = "/DesignSystem/EditAutomation/PreUpdate/Content/TotalAffected"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let automationUpdateImpactTotalAffectedValueData = fromData.useDataValue({ viewPath,
context: 'automation',
path: 'update_impact.total_affected',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(automationUpdateImpactTotalAffectedValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}